const Discontinued = () => {
  return (
    <svg
      aria-hidden="true"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.351685 0.282227C0.749095 -0.102429 1.38104 -0.0926933 1.76575 0.304688L3.83997 2.44824L5.95032 0.338867C6.34142 -0.0522306 6.97326 -0.0521894 7.36438 0.338867C7.7555 0.729986 7.7555 1.36181 7.36438 1.75293L5.23157 3.88477L7.3302 6.05273C7.71467 6.45016 7.70408 7.08215 7.30676 7.4668C6.90935 7.85144 6.2774 7.84074 5.8927 7.44336L3.81751 5.2998L1.70813 7.41016C1.31701 7.80127 0.68421 7.80127 0.293091 7.41016C-0.097821 7.01918 -0.0975731 6.38723 0.293091 5.99609L2.4259 3.8623L0.328247 1.69629C-0.0564813 1.29888 -0.0457207 0.666955 0.351685 0.282227Z"
        fill="#999999"
      />
    </svg>
  )
}

export default Discontinued
